// extracted by mini-css-extract-plugin
export default {"pulse_header":"slide_show_header_pulse_header__1COOq"};